import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "custom-pin",
  templateUrl: "./custom-pin.component.html",
  standalone: false,
})
export class CustomPinComponent {
  _height: any;

  _width: any;

  _strokeColor: string;

  _fillColor: string;

  @Input()
  set height(height: any) {
    this._height = height;
  }

  @Input()
  set width(width: any) {
    this._width = width;
  }

  @Input()
  set strokeColor(color: string) {
    this._strokeColor = color;
  }

  @Input()
  set fillColor(color: string) {
    this._fillColor = color;
  }
}
